import { axios } from '../../../axios';

const loginApi = (data) => {
  return axios.post('/users/auth/login', data)
}
const signupApi = (data) => {
  return axios.post('/users/auth/register', data)
}
const forgetPasswordFunction = (data) => {
  return axios.post('/users/auth/forget-password', data)
}
const sendOtpApi = (data) => {
  return axios.post('/users/auth/send-otp', data)
}

const verifyOtpApi = (data) => {
  console.log(data)
  return axios.post('/users/auth/verify-otp', data)
}
const resetPasswordApi = (data) => {
  return axios.post('/users/auth/reset-password', data)
}

const newPasswordApi = (data) => {
  return axios.patch('/users/info/password', data)
}

export { loginApi, signupApi, forgetPasswordFunction, sendOtpApi, resetPasswordApi, verifyOtpApi, newPasswordApi }